module.exports = {"id":"231240","name":"Emre Mor","rating":"74","photo":"./data/images/photos/4/231240.png","club":{"name":"Celta Vigo","logo":"./data/images/clubs/CeltaVigo.png"},"positions":["AD","BU","AG","ATT"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EmreMor0.json
// module id = 1249
// module chunks = 0